import React, { useEffect, useState } from 'react'
import { X, Loader2, BarChart3, Inbox } from 'lucide-react'
import { resultApi } from '../api/lessonBuilderApi'

interface Props {
  lessonId: string
  lessonTitle?: string
  onClose: () => void
}

const ResultsModal: React.FC<Props> = ({ lessonId, lessonTitle, onClose }) => {
  const [rows, setRows] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    resultApi.list(lessonId).then((r) => {
      setRows(r)
      setLoading(false)
    })
  }, [lessonId])

  const avg =
    rows.length > 0
      ? rows.reduce((s, r) => s + (r.max_score ? (r.score / r.max_score) * 10 : 0), 0) / rows.length
      : 0

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] flex flex-col shadow-xl">
        <div className="flex items-center justify-between p-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <BarChart3 className="text-blue-600" size={20} />
            <h2 className="text-lg font-black text-gray-900">Kết quả học tập</h2>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-700"><X size={22} /></button>
        </div>

        <div className="px-4 py-2 border-b border-gray-50 text-sm text-gray-500">
          {lessonTitle && <span className="font-semibold text-gray-700">{lessonTitle}</span>}
          {rows.length > 0 && <span> · {rows.length} lượt làm · TB quy đổi 10: <strong className="text-blue-700">{avg.toFixed(1)}</strong></span>}
        </div>

        <div className="overflow-y-auto p-3">
          {loading ? (
            <div className="flex justify-center py-12"><Loader2 className="w-6 h-6 animate-spin text-gray-300" /></div>
          ) : rows.length === 0 ? (
            <div className="flex flex-col items-center py-12 text-gray-300">
              <Inbox size={40} className="mb-2" />
              <p className="text-gray-400 text-sm">Chưa có lượt làm bài nào.</p>
            </div>
          ) : (
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-400 border-b border-gray-100">
                  <th className="py-2 px-2">Học sinh</th>
                  <th className="py-2 px-2">Điểm</th>
                  <th className="py-2 px-2">Đúng</th>
                  <th className="py-2 px-2">Thời gian</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {rows.map((r) => (
                  <tr key={r.id}>
                    <td className="py-2 px-2">
                      <div className="font-semibold text-gray-800">{r.student_name || '—'}</div>
                      <div className="text-[11px] text-gray-400">{r.student_email}</div>
                    </td>
                    <td className="py-2 px-2 font-bold text-blue-700">{r.score}/{r.max_score}</td>
                    <td className="py-2 px-2 text-gray-600">{r.correct}/{r.total}</td>
                    <td className="py-2 px-2 text-gray-400 text-xs">{r.created_at ? new Date(r.created_at).toLocaleString('vi-VN') : ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  )
}

export default ResultsModal
